import CrudCustom from '../../../libs/custom/CrudCustom';

let PengecualianPajakService = new CrudCustom('/tipe-pengecualian-pajaks');
export default PengecualianPajakService;
